import React from "react";

const CITIES = [
    "Варшава", "Краків", "Київ", "Львів", "Вроцлав",
    "Гданськ", "Одеса", "Лодзь", "Харків", "Познань",
];

export const Marquee = () => {
    const items = [...CITIES, ...CITIES];
    return (
        <div
            data-testid="cities-marquee"
            className="relative border-y border-border py-5 overflow-hidden bg-surface/30"
        >
            <div className="marquee-track">
                {items.map((c, i) => (
                    <div key={i} className="flex items-center gap-12 pr-12 whitespace-nowrap">
                        <span className="text-sm text-secondary-c uppercase tracking-[0.18em]">
                            {c}
                        </span>
                        <span className="text-primary-c opacity-40">·</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Marquee;
